/**
 * Slider
 * Author: Kyle Shearer
 */

import State from "./State";

var Slideshow = (function () {
    var options = {
        slider: $(".js-slideshow"),
        arrows: false,
        dots: true,
    };

    function init(params) {
        options = $.extend({}, options, params);

        if (canInit()) {
            console.log("Slideshow initialized");
            initializeFirstSlideText();
            updateText();
            slider();
            startControls();
        }
    }

    function canInit() {
        var canInit = sliderExists();
        return canInit;
    }

    function checkIfMobile(mq) {
        if (mq.matches) {
            return true;
        } else {
            return false;
        }
    }

    function sliderExists(mq) {
        if (options.slider.length && jQuery.fn.slick) {
            return true;
        } else {
            return false;
        }
    }

    function slider() {
        options.slider.slick({
            dots: false,
            cssEase: "ease-in-out",
            autoplay: true,
            arrows: false,
            speed: 1000,
        });
    }

    function updateText() {
        $(".js-slideshow").on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
                State.currentSlide = nextSlide;
                updateSlidesText();
            }
        );
    }

    function initializeFirstSlideText() {
        updateSlidesText();
    }

    function startControls() {
        $(".js-previous-slide").click(function () {
            $(".js-slideshow").slick("slickPrev");
        });
        $(".js-next-slide").click(function () {
            $(".js-slideshow").slick("slickNext");
        });
    }

    function updateSlidesText() {
        const imagesText = document.querySelectorAll(".js-hero-text-wrapper");
        for (let i = 0; i < imagesText.length; i++) {
            const imageTextId = imagesText[i].getAttribute("id");
            if (State.currentSlide == imageTextId) {
                imagesText[i].classList.add("active");
            } else {
                imagesText[i].classList.remove("active");
            }
        }
    }

    return {
        init: init,
    };
})();

$(function () {
    "use strict";
    Slideshow.init();
});
